/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

var Model = require("../types/Model.js");
var window = require("global");

module.exports = Model({
	name: "notifications",
	init: init,
	triggers: triggers,
});

function init() {
	if (!window.Notification)
		return this.push(false);
}

function triggers() {
	return {
		"show": show
	};
}

function show(data) {
	var title = data.title;
	var body = data.body;
	var tag = data.tag;
	var image = data.image;
	var options = {};

	if (body) options.body = body;
	if (tag) options.tag = tag;
	if (image) {
		options.icon = image;
	} else options.icon = "file://images/Aetonix_icon.png";

	new window.Notification(title, options);
}
